import React, { useState } from "react";
import Axios from "../../services/AxiosInstance";

const AddCourse = () => {

  const [formData, setFormData] = useState({
    courseName: "",
    category: "",
    level: "",
    description: "",
    learning: "",
    duration: "",
    path: "",
    instructor: "",
    price: "",
    startDate: "",
    comments: "",
    audience: ""
  });

  const [errors, setErrors] = useState({});

  // handle input
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    setErrors({ ...errors, [name]: "" });
  };

  // word limit
  const handleWordLimit = (e) => {
    const { name, value } = e.target;
    const words = value.trim().split(/\s+/).filter(Boolean);

    if (words.length <= 50) {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  // validation
  const validate = () => {
    let newErrors = {};

    if (!formData.courseName.trim())
      newErrors.courseName = "Course Name is required";

    if (!formData.category)
      newErrors.category = "Category is required";

    if (!formData.level)
      newErrors.level = "Level is required";

    if (!formData.description.trim())
      newErrors.description = "Description is required";

    if (!formData.learning.trim())
      newErrors.learning = "Learning Objective is required";

    if (!formData.duration.trim())
      newErrors.duration = "Duration is required";

    if (!formData.path.trim())
      newErrors.path = "Path is required";

    if (!formData.instructor.trim())
      newErrors.instructor = "Instructor is required";

    if (!formData.price)
      newErrors.price = "Price is required";

    if (!formData.startDate)
      newErrors.startDate = "Start Date is required";

    if (!formData.comments.trim())
      newErrors.comments = "Comments is required";

    if (!formData.audience.trim())
      newErrors.audience = "Audience is required";

    return newErrors;
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {

      const response = await Axios.post(
        `/api/courses`,
        {
          courseName: formData.courseName,
          category: formData.category,
          level: formData.level,
          description: formData.description,
          learningObjective: formData.learning,
          duration: formData.duration,
          path: formData.path,
          instructor: formData.instructor,
          price: Number(formData.price),
          startDate: formData.startDate,
          comments: formData.comments,
          targetedAudience: formData.audience
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("SUCCESS:", response.data);

      alert("🎉 Course Added Successfully");

      // reset form
      setFormData({
        courseName: "",
        category: "",
        level: "",
        description: "",
        learning: "",
        duration: "",
        path: "",
        instructor: "",
        price: "",
        startDate: "",
        comments: "",
        audience: ""
      });

    } catch (error) {

      console.log("ERROR:", error.response);

      alert(
        error.response?.data?.message ||
        "Something went wrong"
      );
    }
  };

  return (
    <div
      style={{
        marginLeft: "400px",
        marginTop: "5px",
        padding: "10px"
      }}
    >

      <div className="job-card">

        <h3 className="job-title">
          ADD COURSE
        </h3>

        <form onSubmit={handleSubmit}>

          {/* Course Name */}
          <div className="form-group">

            <label>Course Name</label>

            <input
              type="text"
              name="courseName"
              value={formData.courseName}
              onChange={handleChange}
              className={
                errors.courseName
                  ? "error-input"
                  : ""
              }
            />

            {errors.courseName && (
              <small className="error-text">
                {errors.courseName}
              </small>
            )}

          </div>

          {/* Category */}
          <div className="form-group">

            <label>Category</label>

            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className={
                errors.category
                  ? "error-input"
                  : ""
              }
            >

              <option value="">
                Select Category
              </option>

              <option value="Full Stack">
                Full Stack
              </option>

              <option value="Cloud">
                Cloud
              </option>

              <option value="Digital Marketing">
                Digital Marketing
              </option>

              <option value="Artificial Intelligence (AI)">
                Artificial Intelligence (AI)
              </option>

            </select>

            {errors.category && (
              <small className="error-text">
                {errors.category}
              </small>
            )}

          </div>

          {/* Level */}
          <div className="form-group">

            <label>Level</label>

            <select
              name="level"
              value={formData.level}
              onChange={handleChange}
              className={
                errors.level
                  ? "error-input"
                  : ""
              }
            >

              <option value="">
                Select Level
              </option>

              <option>Beginner</option>

              <option>Intermediate</option>

              <option>Advanced</option>

            </select>

            {errors.level && (
              <small className="error-text">
                {errors.level}
              </small>
            )}

          </div>

          {/* Description */}
          <div className="form-group">

            <label>Description</label>

            <textarea
              name="description"
              value={formData.description}
              onChange={handleWordLimit}
              className={
                errors.description
                  ? "error-input"
                  : ""
              }
            />

            {errors.description && (
              <small className="error-text">
                {errors.description}
              </small>
            )}

          </div>

          {/* Learning */}
          <div className="form-group">

            <label>Learning Objective</label>

            <textarea
              name="learning"
              value={formData.learning}
              onChange={handleWordLimit}
              className={
                errors.learning
                  ? "error-input"
                  : ""
              }
            />

            {errors.learning && (
              <small className="error-text">
                {errors.learning}
              </small>
            )}

          </div>

          {/* Duration */}
          <div className="form-group">

            <label>Duration</label>

            <input
              type="text"
              name="duration"
              value={formData.duration}
              onChange={handleChange}
              className={
                errors.duration
                  ? "error-input"
                  : ""
              }
            />

            {errors.duration && (
              <small className="error-text">
                {errors.duration}
              </small>
            )}

          </div>

          {/* Path */}
          <div className="form-group">

            <label>Path</label>

            <input
              type="text"
              name="path"
              value={formData.path}
              onChange={handleChange}
              className={
                errors.path
                  ? "error-input"
                  : ""
              }
            />

            {errors.path && (
              <small className="error-text">
                {errors.path}
              </small>
            )}

          </div>

          {/* Instructor */}
          <div className="form-group">

            <label>Instructor</label>

            <input
              type="text"
              name="instructor"
              value={formData.instructor}
              onChange={handleChange}
              className={
                errors.instructor
                  ? "error-input"
                  : ""
              }
            />

            {errors.instructor && (
              <small className="error-text">
                {errors.instructor}
              </small>
            )}

          </div>

          {/* Price */}
          <div className="form-group">

            <label>Price</label>

            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className={
                errors.price
                  ? "error-input"
                  : ""
              }
            />

            {errors.price && (
              <small className="error-text">
                {errors.price}
              </small>
            )}

          </div>

          {/* Start Date */}
          <div className="form-group">

            <label>Start Date</label>

            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              className={
                errors.startDate
                  ? "error-input"
                  : ""
              }
            />

            {errors.startDate && (
              <small className="error-text">
                {errors.startDate}
              </small>
            )}

          </div>

          {/* Comments */}
          <div className="form-group">

            <label>Comments</label>

            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleWordLimit}
              className={
                errors.comments
                  ? "error-input"
                  : ""
              }
            />

            {errors.comments && (
              <small className="error-text">
                {errors.comments}
              </small>
            )}

          </div>

          {/* Audience */}
          <div className="form-group">

            <label>Targeted Audience</label>

            <textarea
              name="audience"
              value={formData.audience}
              onChange={handleWordLimit}
              className={
                errors.audience
                  ? "error-input"
                  : ""
              }
            />

            {errors.audience && (
              <small className="error-text">
                {errors.audience}
              </small>
            )}

          </div>

          <center>

            <button className="submit-btn">
              Submit Course
            </button>

          </center>

        </form>

      </div>

    </div>
  );
};

export default AddCourse;